import type { CustomFlowbiteTheme } from 'flowbite-react';

export const alertTheme: CustomFlowbiteTheme['alert'] = {
  base: 'flex flex-col gap-2 p-4 text-sm font-maison',
  borderAccent: 'border-t-4',
  closeButton: {
    base: '-m-1.5 ml-auto inline-flex h-8 w-8 rounded-lg p-1.5 focus:ring-2',
    icon: 'h-5 w-5',
    color: {
      info: 'bg-titan-blue-100 text-titan-blue-600 hover:bg-titan-blue-200 focus:ring-titan-blue-400',
      gray: 'bg-titan-night-100 text-titan-night-600 hover:bg-titan-night-200 focus:ring-titan-night-400',
      failure:
        'bg-titan-folly-100 text-titan-folly-600 hover:bg-titan-folly-200 focus:ring-titan-folly-400',
      success:
        'bg-green-100 text-green-600 hover:bg-green-200 focus:ring-green-400',
      warning:
        'bg-titan-yellow-100 text-titan-yellow-600 hover:bg-titan-yellow-200 focus:ring-titan-yellow-400',
      red: 'bg-titan-folly-100 text-titan-folly-600 hover:bg-titan-folly-200 focus:ring-titan-folly-400',
      green:
        'bg-green-100 text-green-600 hover:bg-green-200 focus:ring-green-400',
      yellow:
        'bg-titan-yellow-100 text-titan-yellow-600 hover:bg-titan-yellow-200 focus:ring-titan-yellow-400',
    },
  },
  color: {
    info: 'bg-titan-blue-100 text-titan-blue-700',
    gray: 'bg-titan-night-100 text-titan-night-700',
    failure: 'bg-titan-folly-100 text-titan-folly-700',
    success: 'bg-green-100 text-green-700',
    warning: 'bg-titan-yellow-100 text-titan-yellow-700',
    red: 'bg-titan-folly-100 text-titan-folly-700',
    green: 'bg-green-100 text-green-700',
    yellow: 'bg-titan-yellow-100 text-titan-yellow-700',
    blue: 'bg-titan-blue-100 text-titan-blue-700',
    cyan: 'bg-titan-blue-100 text-titan-blue-700',
    pink: 'bg-titan-folly-100 text-titan-folly-700',
    lime: 'bg-titan-yellow-100 text-titan-yellow-700',
    dark: 'bg-titan-night-100 text-titan-night-700',
    indigo: 'bg-titan-blue-100 text-titan-blue-700',
    purple: 'bg-titan-folly-100 text-titan-folly-700',
    teal: 'bg-titan-blue-100 text-titan-blue-700',
    light: 'bg-titan-night-50 text-titan-night-600',
  },
  icon: 'mr-3 inline h-5 w-5 shrink-0',
  rounded: 'rounded-lg',
  wrapper: 'flex items-center',
};
